var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.409746 -0.087636L0.128797 0.207171C0.0410571 0.299953 -0.00727959 0.423392 -0.00727959 0.55532C-0.00727959 0.687175 0.0410571 0.810761 0.128797 0.903543L3.31168 4.2665L0.125265 7.63333C0.0375253 7.72596 -0.0107422 7.84955 -0.0107422 7.9814C-0.0107422 8.11326 0.0375253 8.23692 0.125265 8.32963L0.404483 8.62451C0.586057 8.81651 0.881825 8.81651 1.0634 8.62451L4.87085 4.61589C4.95852 4.52325 5.02029 4.39982 5.02029 4.26679V4.26525C5.02029 4.13333 4.95845 4.00988 4.87085 3.91725L1.07372 -0.087636C0.986046 -0.180417 0.86569 -0.231344 0.740901 -0.231491C0.616042 -0.231491 0.497347 -0.180417 0.409746 -0.087636Z",
    fill: "#4A4FC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.32b93e57f87d9a4d602fa54a46c91b73.svg";
export { ForwardRef as ReactComponent };